import { useContext } from "react";
import React from "react";
import { FaPoundSign } from "react-icons/fa";
import { IoIosCalculator } from "react-icons/io";
import { DataContext } from "../components/DataProvider";
import { useFormik } from "formik";
import * as Yup from "yup";

const mortgageAmountSection = {
  label: "mortgage_amount",
  title: "Mortgage amount",
  icon: <FaPoundSign size={20} />,
  type: "text",
};

const mortgageTypeSection = [
  {
    id: "repayment",
    title: "Repayment",
    type: "radio",
  },

  {
    id: "interest_rate",
    title: "Interest Only",
    type: "radio",
  },
];

const CalculatorForm = () => {
  const { updateFormData } = useContext(DataContext);

  const formik = useFormik({
    initialValues: {
      amount: "",
      years: "",
      interestRate: "",
    },

    validationSchema: Yup.object().shape({
      amount: Yup.string().required("Mortgage Amount is required"),
      years: Yup.string().required("No of Years is required"),
      interestRate: Yup.string().required("Interest Rate is required"),
    }),

    onSubmit: (values) => {
      updateFormData(values);
    },
  });

  const ClearForm = () => {
    formik.resetForm();
  };

  return (
    <div>
      <div className=" container shadow-lg shadow-blue-800 bg-white border max-w-full py-10 sm:max-h-[520px]">
        <div className=" flex flex-col items-center gap-3  sm:flex sm:flex-row sm:justify-around text-lg">
          <h1 className="font-semibold ">Mortagage Calculator</h1>
          <h2
            onClick={() => ClearForm()}
            className="cursor-pointer underline text-blue-400  font-light"
          >
            Clear All
          </h2>
        </div>

        <form id="Form" onSubmit={formik.handleSubmit}>
          {/* MORTGAGE AMOUNT SECTION*/}
          <div className=" flex flex-col p-2  justify-center">
            <div className="group ml-4 mt-10">
              <label for={mortgageAmountSection.label} className=" text-sm">
                {mortgageAmountSection.title}
              </label>
              <div className="flex mt-3 group-hover:border group-hover:border-yellow-400  max-w-sm  rounded-lg shadow-sm">
                <span className="px-2 font-bold inline-flex group-hover:bg-green-500 items-center min-w-fit rounded-s-md border border-e-0 border-gray-200 bg-gray-200 text-sm text-gray-500 dark:bg-neutral-700 dark:border-neutral-700 dark:text-neutral-400">
                  {mortgageAmountSection.icon}
                </span>
                <input
                  type={mortgageAmountSection.type}
                  name="amount"
                  value={formik.values.amount}
                  placeholder="Mortgage Amount"
                  id={mortgageAmountSection.label}
                  className="py-2 px-2 cursor-pointer w-full  font-bold  border border-gray-500  shadow-sm rounded-e-lg text-sm  disabled:opacity-50 disabled:pointer-events-none"
                  onChange={formik.handleChange}
                />
              </div>
              <span className=" text-red-800 text-sm">
                {formik.errors.amount && formik.touched && formik.errors.amount}
              </span>
            </div>

            {/* LOAN DETAILS SECTION*/}
            <div className=" flex flex-col ml-4   sm:flex sm:flex-row">
              <div className="flex flex-col  gap-24 sm:flex sm:flex-row ">
                <div className="mt-10">
                  <label for="mortgage_term" className=" text-sm">
                    Mortgage Term
                  </label>

                  <div className="flex flex-col gap-10 sm:flex sm:flex-row">
                    <div className="flex mt-3 group-hover:border hover:border-yellow-400  border border-gray-500 rounded-sm shadow-sm ">
                      <input
                        type="text"
                        id="years"
                        name="years"
                        value={formik.values.years}
                        className="py-2 px-2  cursor-pointer font-bold w-full sm:max-w-[100px] outline-none text-sm"
                        placeholder="No of Years"
                        onChange={formik.handleChange}
                        required
                      />

                      <span className="px-2 font-bold inline-flex hover:bg-green-500 items-center min-w-fit w-auto  border rounded-sm bg-gray-200  text-sm text-gray-500 ">
                        years
                      </span>
                    </div>

                    <div className="flex mt-3 hover:border hover:border-yellow-400  border border-gray-500 rounded-sm shadow-sm ">
                      <input
                        type="text"
                        id="interest_rate"
                        name="interestRate"
                        value={formik.values.interestRate}
                        placeholder="Interest Rate"
                        className="py-2 px-2 cursor-pointer w-full font-bold  outline-none text-sm"
                        onChange={formik.handleChange}
                        required
                      />
                      <span className="px-2 font-bold hover:bg-green-500 inline-flex items-center  w-auto  border rounded-sm bg-gray-200  text-sm text-gray-500 ">
                        %
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* MORTGAGE TYPE SECTION*/}
            <div className=" flex flex-col  ml-4 max-w-sm mt-2 gap-2">
              <label for="mortgage_type" className=" text-sm">
                Mortgage Type
              </label>
              {mortgageTypeSection.length > 0 &&
                mortgageTypeSection.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="hover:border  hover:border-yellow-400 hover:bg-green-300"
                    >
                      <div className="flex rounded-lg shadow-sm">
                        <span className="px-4 inline-flex items-center min-w-fit rounded-s-md border border-e-0 border-gray-200 bg-gray-50 text-sm text-gray-500 dark:bg-neutral-700 dark:border-neutral-700 dark:text-neutral-400">
                          <span className="flex">
                            <input
                              type={item.type}
                              name="mortgage_type"
                              className="shrink-0 rounded-full text-blue-600 focus:ring-blue-500 dark:bg-neutral-800 dark:border-neutral-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800"
                              id="hs-input-group-with-radio"
                            />
                            <label
                              for="hs-input-group-with-radio"
                              className="sr-only"
                            >
                              Radio
                            </label>
                          </span>
                        </span>
                        <input
                          type="text"
                          value={item.title}
                          id={item.id}
                          className="py-2 font-semibold border border-b-1 border-gray-300  text-black px-3 pe-11 block w-full  rounded-e-lg text-sm"
                          disabled
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className=" ml-4 mt-5">
              <button
                type="submit"
                className="focus:outline-none inline-flex gap-2 text-black bg-yellow-400 hover:bg-yellow-500 focus:ring-4 focus:ring-yellow-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:focus:ring-yellow-900"
              >
                <IoIosCalculator size={20} />
                Calculate Repayments
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CalculatorForm;
